export default __webpack_public_path__ + "static/grammatically-transitive-present-efdeebf01e0ca14c68e58d08ee2e7f1e.svg";